import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgYelpLogo = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__yelp-logo_svg__a)">
        <path
          d="M3.488 12a8.5 8.5 0 0 1 8.5-8.5 8.5 8.5 0 0 1 8.5 8.5 8.5 8.5 0 0 1-17 0Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__yelp-logo_svg__b)"
        />
        <path
          d="m10.429 13.338.55-.126c.011-.003.03-.007.054-.015a.608.608 0 0 0 .434-.722l-.002-.01a.615.615 0 0 0-.093-.204.78.78 0 0 0-.224-.193 2.061 2.061 0 0 0-.319-.148l-.604-.219a56.673 56.673 0 0 0-1.018-.367c-.22-.078-.408-.147-.573-.197l-.093-.029a1.66 1.66 0 0 0-.453-.086.545.545 0 0 0-.427.183c-.028.031-.053.065-.078.098a1.139 1.139 0 0 0-.116.23c-.111.33-.167.678-.164 1.027.002.315.011.72.184.994.042.07.098.131.165.18.122.084.249.095.378.105.194.014.382-.033.57-.076l1.829-.425Zm6.13-2.917a3.072 3.072 0 0 0-.597-.85.996.996 0 0 0-.317-.21.59.59 0 0 0-.239-.04.56.56 0 0 0-.224.063 1.63 1.63 0 0 0-.369.275l-.071.067c-.125.116-.262.26-.427.428-.254.257-.504.515-.753.777l-.445.461a2.186 2.186 0 0 0-.223.273.772.772 0 0 0-.118.27.634.634 0 0 0 .005.224l.002.01a.603.603 0 0 0 .706.459c.024-.004.043-.009.054-.01l2.376-.548c.188-.043.377-.083.546-.181.113-.065.221-.13.294-.26a.571.571 0 0 0 .07-.233c.036-.322-.133-.69-.27-.975Zm-4.25 1c.172-.216.17-.538.185-.802.052-.88.106-1.76.148-2.64.017-.334.051-.662.032-.998-.017-.277-.019-.596-.195-.823-.308-.402-.97-.369-1.417-.306a4.52 4.52 0 0 0-.414.079 5.61 5.61 0 0 0-.405.11c-.432.142-1.038.4-1.14.899-.059.28.08.568.185.825.13.31.306.591.467.883.425.772.858 1.54 1.29 2.308.13.229.269.52.52.639a.588.588 0 0 0 .05.018.601.601 0 0 0 .652-.15.452.452 0 0 0 .041-.042Zm-.208 2.355a.55.55 0 0 0-.613-.206.664.664 0 0 0-.184.1c-.1.073-.183.17-.26.264-.02.025-.036.057-.059.078l-.382.525c-.216.294-.43.59-.642.888-.138.194-.258.357-.352.501l-.053.082a1.557 1.557 0 0 0-.21.416.536.536 0 0 0-.023.234.58.58 0 0 0 .082.233c.023.035.048.07.074.103.029.031.057.061.088.091.034.032.068.06.105.086a3.357 3.357 0 0 0 1.638.567 1.068 1.068 0 0 0 .382-.056.583.583 0 0 0 .208-.134.542.542 0 0 0 .126-.197 1.57 1.57 0 0 0 .091-.457c.002-.03.007-.065.009-.098.015-.172.021-.373.033-.612a60.6 60.6 0 0 0 .045-1.094l.025-.65c.005-.149 0-.315-.042-.463a.633.633 0 0 0-.086-.2Zm4.316 1.015a1.613 1.613 0 0 0-.372-.283 2.146 2.146 0 0 1-.083-.05c-.147-.089-.327-.182-.536-.296-.32-.176-.643-.347-.966-.518l-.573-.304c-.03-.008-.06-.03-.088-.043a1.431 1.431 0 0 0-.349-.125.653.653 0 0 0-.207-.008.55.55 0 0 0-.45.67c.028.153.096.303.166.436l.306.572c.17.324.343.644.52.965.114.209.208.387.296.536.017.028.037.058.05.083.108.178.194.29.284.37a.556.556 0 0 0 .2.123c.079.027.164.035.245.027a1.08 1.08 0 0 0 .124-.022c.04-.012.082-.023.12-.038.043-.017.083-.035.123-.057a3.348 3.348 0 0 0 1.225-1.227 1.08 1.08 0 0 0 .095-.242c.01-.041.016-.083.021-.124a.58.58 0 0 0-.028-.244.523.523 0 0 0-.123-.201Z"
          fill="#fff"
        />
      </g>
      <defs>
        <radialGradient
          id="src__com__yext__listingslaunchstorm__public__icons__yelp-logo_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(90 5.233 6.756) scale(20.2997)"
        >
          <stop stopColor="#FF78A1" />
          <stop offset={0.513} stopColor="#FE375C" />
          <stop offset={1} stopColor="red" />
        </radialGradient>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__yelp-logo_svg__a">
          <path fill="#fff" transform="translate(3.5 3.5)" d="M0 0h17v17H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgYelpLogo;
